module.exports = __webpack_public_path__ + "static/visionar-mobile-app-demonstration-438c71de0a5d900100a171af23852df2.mp4";